import { AppTableFilters } from 'services/AppTableFilters';
import { t } from 'i18next';

export const appTableFiltersInstance = new AppTableFilters();

export const usersTableColumns = (store) => [
  {
    id: 'email',
    Header: t('email'),
    accessor: 'email',
    maxWidth: 100,
    filter: {
      id: 'email',
      type: 'textfields',
      onApply: ({ email }: { email: string }) => {
        if (email) {
          appTableFiltersInstance.addFilter({
            id: 'email',
            type: 'textfields',
            label: `${t('email')}: ${email}`,
            field: 'email',
            value: email,
          });
        }
      },
      inputs: [
        {
          id: 'email',
          field: 'email',
          label: t('email'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'firstName',
    Header: t('firstName'),
    accessor: 'firstName',
    maxWidth: 80,
    filter: {
      id: 'firstName',
      type: 'textfields',
      onApply: ({ firstName }: { firstName: string }) => {
        if (firstName) {
          appTableFiltersInstance.addFilter({
            id: 'firstName',
            type: 'textfields',
            label: `${t('firstName')}: ${firstName}`,
            field: 'firstName',
            value: firstName,
          });
        }
      },
      inputs: [
        {
          id: 'firstName',
          // this is the field inside the data object that should be used to filter the data
          field: 'firstName',
          label: t('firstName'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'lastName',
    Header: t('lastName'),
    accessor: 'lastName',
    maxWidth: 80,
    filter: {
      id: 'lastName',
      type: 'textfields',
      onApply: ({ lastName }: { lastName: string }) => {
        if (lastName) {
          appTableFiltersInstance.addFilter({
            id: 'lastName',
            type: 'textfields',
            label: `${t('lastName')}: ${lastName}`,
            field: 'lastName',
            value: lastName,
          });
        }
      },
      inputs: [
        {
          id: 'lastName',
          // this is the field inside the data object that should be used to filter the data
          field: 'lastName',
          label: t('lastName'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'type',
    Header: t('type'),
    accessor: 'role',
    maxWidth: 80,
    filter: {
      id: 'type',
      type: 'select',
      field: 'role',
      label: t('type'),
      value: '',
      options: store.userRoles.map((role) => ({ label: t(`${role.toLowerCase()}`), value: role })),
      onApply: (type) => {
        if (type) {
          appTableFiltersInstance.addFilter({
            id: 'type',
            type: 'select',
            label: `${t('type')}: ${t(`${type?.toLowerCase()}`)}`,
            field: 'role',
            value: type,
            options: store.userRoles.map((role) => ({ label: t(`${role.toLowerCase()}`), value: role })),
          });
        }
      },
    },
  },

  {
    id: 'userId',
    Header: t('userId'),
    accessor: 'id',
    maxWidth: 80,
    filter: {
      id: 'userId',
      type: 'textfields',
      onApply: ({ userId }: { userId: string }) => {
        if (userId) {
          appTableFiltersInstance.addFilter({
            id: 'userId',
            type: 'textfields',
            label: `${t('userId')}: ${userId}`,
            field: 'id',
            value: userId,
          });
        }
      },
      inputs: [
        {
          id: 'userId',
          // this is the field inside the data object that should be used to filter the data
          field: 'userId',
          label: t('userId'),
          value: '',
        },
      ],
    },
  },
  {
    id: 'actions',
    Header: t('actions'),
    maxWidth: 80,
  },
];
